module.exports = __webpack_public_path__ + "img/1.a86d5585.png";